import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PWALayout from './PWALayout';
import PWAHomeScreen from './PWAHomeScreen';
import PWAProductList from './PWAProductList';
import PWAAllProducts from './PWAAllProducts';
import PWAMoreMenu from './PWAMoreMenu';
import PWAPageWrapper from './PWAPageWrapper';

// Import existing pages for PWA wrapper
import Cart from '../../pages/Cart';
import Contact from '../../pages/Contact';
import ProductDetail from '../../pages/ProductDetail';
import AccessoryDetail from '../../pages/AccessoryDetail';
import FAQ from '../../pages/FAQ';
import Garantiebedingungen from '../../pages/Garantiebedingungen';
import Gewaehrleistung from '../../pages/Gewaehrleistung';
import AGB from '../../pages/AGB';
import Widerrufsbelehrung from '../../pages/Widerrufsbelehrung';
import Zahlungsarten from '../../pages/Zahlungsarten';
import Datenschutz from '../../pages/Datenschutz';
import Impressum from '../../pages/Impressum';
import About from '../../pages/About';
import PartnerWerden from '../../pages/PartnerWerden';
import Preorder from '../../pages/Preorder';

/**
 * PWA App - Vollständige App mit allen Routes
 * Alle Funktionen der Website im App-Design
 */
const PWAApp = () => {
  return (
    <PWALayout>
      <Routes>
        {/* Home */}
        <Route path="/" element={<PWAHomeScreen />} />
        
        {/* Alle Produkte - für "Produkte" Tab */}
        <Route path="/produkte" element={<PWAAllProducts />} />
        
        {/* Produkt-Kategorien */}
        <Route path="/bagger" element={<PWAProductList category="Mini-Bagger" title="Bagger" basePath="/bagger" />} />
        <Route path="/radlader" element={<PWAProductList category="Radlader" title="Radlader" basePath="/radlader" />} />
        <Route path="/gabelstapler" element={<PWAProductList category="Gabelstapler" title="Gabelstapler" basePath="/gabelstapler" />} />
        <Route path="/ruettelplatten" element={<PWAProductList category="Rüttelplatten" title="Rüttelplatten" basePath="/ruettelplatten" />} />
        <Route path="/stampfer" element={<PWAProductList category="Stampfer" title="Stampfer" basePath="/stampfer" />} />
        <Route path="/zubehoer" element={<PWAProductList category="Zubehör" title="Zubehör" basePath="/zubehoer" isAccessory={true} />} />
        
        {/* Produkt-Details */}
        <Route path="/bagger/:slug" element={<PWAPageWrapper title="Produktdetails"><ProductDetail /></PWAPageWrapper>} />
        <Route path="/radlader/:slug" element={<PWAPageWrapper title="Produktdetails"><ProductDetail /></PWAPageWrapper>} />
        <Route path="/gabelstapler/:slug" element={<PWAPageWrapper title="Produktdetails"><ProductDetail /></PWAPageWrapper>} />
        <Route path="/ruettelplatten/:slug" element={<PWAPageWrapper title="Produktdetails"><ProductDetail /></PWAPageWrapper>} />
        <Route path="/stampfer/:slug" element={<PWAPageWrapper title="Produktdetails"><ProductDetail /></PWAPageWrapper>} />
        <Route path="/zubehoer/:slug" element={<PWAPageWrapper title="Zubehör"><AccessoryDetail /></PWAPageWrapper>} />
        
        {/* Warenkorb */}
        <Route path="/warenkorb" element={<PWAPageWrapper title="Warenkorb"><Cart /></PWAPageWrapper>} />
        
        {/* Kontakt */}
        <Route path="/kontakt" element={<PWAPageWrapper title="Kontakt"><Contact /></PWAPageWrapper>} />
        
        {/* Mehr-Menü */}
        <Route path="/mehr" element={<PWAMoreMenu />} />
        
        {/* Service-Seiten */}
        <Route path="/faq" element={<PWAPageWrapper title="FAQ"><FAQ /></PWAPageWrapper>} />
        <Route path="/garantiebedingungen" element={<PWAPageWrapper title="Garantie"><Garantiebedingungen /></PWAPageWrapper>} />
        <Route path="/gewaehrleistung" element={<PWAPageWrapper title="Gewährleistung"><Gewaehrleistung /></PWAPageWrapper>} />
        <Route path="/vorbestellen" element={<PWAPageWrapper title="Vorbestellen"><Preorder /></PWAPageWrapper>} />
        <Route path="/partner-werden" element={<PWAPageWrapper title="Partner werden"><PartnerWerden /></PWAPageWrapper>} />
        
        {/* Rechtliches */}
        <Route path="/agb" element={<PWAPageWrapper title="AGB"><AGB /></PWAPageWrapper>} />
        <Route path="/widerrufsbelehrung" element={<PWAPageWrapper title="Widerruf"><Widerrufsbelehrung /></PWAPageWrapper>} />
        <Route path="/zahlungsarten" element={<PWAPageWrapper title="Zahlungsarten"><Zahlungsarten /></PWAPageWrapper>} />
        <Route path="/datenschutz" element={<PWAPageWrapper title="Datenschutz"><Datenschutz /></PWAPageWrapper>} />
        <Route path="/impressum" element={<PWAPageWrapper title="Impressum"><Impressum /></PWAPageWrapper>} />
        
        {/* Über uns */}
        <Route path="/ueber-uns" element={<PWAPageWrapper title="Über uns"><About /></PWAPageWrapper>} />
        
        {/* Fallback */}
        <Route path="*" element={<PWAHomeScreen />} />
      </Routes>
    </PWALayout>
  );
};

export default PWAApp;
